import {
  H2,
  P_REGULAR,
  SPACING_3_2,
  SUBTITLE,
} from "../../../Constants/CommonConstants";
import { Stack, Typography } from "@mui/material";
import {
  NAME_AND_CONTACT_VERIFICATION_CONTENT_1,
  NAME_AND_CONTACT_VERIFICATION_HEADER,
} from "../../../Constants/NameAndContactConstants";
import { useIntl } from "react-intl";

/**
 * @description PreferredVerificationMethod component for rendering static text related to Preferred verification method.
 * @returns  {ReactNode} Stack component with typography details
 */
const PreferredVerificationMethod = () => {
  const intl = useIntl();

  return (
    <Stack spacing={SPACING_3_2}>
      <Typography
        id={NAME_AND_CONTACT_VERIFICATION_HEADER}
        component={H2}
        variant={SUBTITLE}
        fontWeight={600}
      >
        {intl.formatMessage({
          id: NAME_AND_CONTACT_VERIFICATION_HEADER,
        })}
      </Typography>
      <Typography
        id={NAME_AND_CONTACT_VERIFICATION_CONTENT_1}
        component={H2}
        variant={P_REGULAR}
      >
        {intl.formatMessage({
          id: NAME_AND_CONTACT_VERIFICATION_CONTENT_1,
        })}
      </Typography>
    </Stack>
  );
};

export default PreferredVerificationMethod;
